import { render, staticRenderFns } from "./u-pagination-text-tile.vue?vue&type=template&id=37e6f6dc&scoped=true&"
import script from "./u-pagination-text-tile.vue?vue&type=script&lang=js&"
export * from "./u-pagination-text-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e6f6dc",
  null
  
)

export default component.exports